import type { TournamentData } from '../../Platform';
import { FakeOverlayTemplate } from '../FakeOverlayTemplate';

export function openFakeTournamentJoinDialog(tournamentData: TournamentData): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const ui = new FakeOverlayTemplate()
      .addText('JOIN TOURNAMENT')
      .addObject(tournamentData)
      .addButton('JOIN', () => {
        resolve(true);
        ui.destroy();
      })
      .addButton('CLOSE', () => {
        resolve(true);
        ui.destroy();
      });
  });
}
